export function getColor(str) {
	if(!str)
		return false

	var hash = 0, color = '#', i, value

	if(!str) {
		return '#333333'
	}

	for (i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash)
	}

	for (i = 0; i < 3; i++) {
		value = (hash >> (i * 8)) & 0xFF
		color += ('00' + value.toString(16)).substr(-2)
	}

	return color;
}

export function getLetter(str) {
	if(str)
		return str.substr(0, 1)
}


// WEBPACK FOOTER //
// ./src/libs/nameToAvatar.js